import { useContext } from "react";
import { DeviceContext } from "@/context/DeviceContext";

export function useIsMobile() {
  const { isMobile } = useContext(DeviceContext);
  return isMobile;
}
